/* tslint:disable */
/* eslint-disable */
/**
 * My App API
 * My App API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ScreenTypeOption
 */
export interface ScreenTypeOption {
    /**
     * 
     * @type {number}
     * @memberof ScreenTypeOption
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof ScreenTypeOption
     */
    groupId: number;
    /**
     * 
     * @type {string}
     * @memberof ScreenTypeOption
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof ScreenTypeOption
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ScreenTypeOption
     */
    nameJa: string;
    /**
     * 
     * @type {string}
     * @memberof ScreenTypeOption
     */
    language: string;
    /**
     * 
     * @type {boolean}
     * @memberof ScreenTypeOption
     */
    isOther: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ScreenTypeOption
     */
    readonly hidden: boolean;
}

export function ScreenTypeOptionFromJSON(json: any): ScreenTypeOption {
    return ScreenTypeOptionFromJSONTyped(json, false);
}

export function ScreenTypeOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScreenTypeOption {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'groupId': json['groupId'],
        'code': json['code'],
        'name': json['name'],
        'nameJa': json['nameJa'],
        'language': json['language'],
        'isOther': json['isOther'],
        'hidden': json['hidden'],
    };
}

export function ScreenTypeOptionToJSON(value?: ScreenTypeOption | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'groupId': value.groupId,
        'code': value.code,
        'name': value.name,
        'nameJa': value.nameJa,
        'language': value.language,
        'isOther': value.isOther,
    };
}


